<template>
    <div style="height: 100%">
        <div id="main2" v-show="!rotaAninhada">
            <container-loader v-if="isLoading && !$store.getters.isLoading" />
            <div class="page">
                <div class="vertical-flow">
                    <div class="listing-header">
                        <div class="title-breadcrumb">
                            <h1 class="title">
                                {{ $t('atendimento') }}
                            </h1>
                            <nav class="breadcrumb" aria-label="breadcrumbs">
                                <ul>
                                    <li>
                                        <a class="a-inativo">{{ $t('promotor') }}</a>
                                    </li>
                                    <li>
                                        <a class="a-inativo">{{ $t('relatorios') }}</a>
                                    </li>
                                    <li>
                                        <a class="a-inativo">{{ $t('atendimento-contrato') }}</a>
                                    </li>
                                    <li>
                                        <a aria-current="page">{{ $t('atendimento') }}</a>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                        <div class="header-buttons">
                            <button
                                class="delete-btn"
                                type="button"
                                @click="$router.push({ name: 'promotor-contrato-list' })"
                            >
                                {{ $t('voltar') }}
                            </button>
                        </div>
                    </div>
                    <div class="filters-bar mb-3">
                        <div class="filters-bar-form form-columns-fit">
                            <div class="columns">
                                <div class="column is-12">
                                    <search-bar ref="search" :onSearch="debouncedOnSearch" tooltipLabel="busca-atendimento-lps" />
                                </div>
                            </div>
                        </div>
                        <div class="filters-bar-actions">
                            <b-button
                                type="is-primary"
                                icon-right="filter"
                                @click="showFilter = !showFilter"
                                v-tippy 
                                :title="$t('filtros')"
                            />
                        </div>
                    </div>

                    <div class="registry-wrapper">
                        <empty-table-message v-if="isEmpty" />
                        <b-table
                            v-else
                            :data="atendimentoList"
                            class="data-table"
                            @sort="sortTable"
                            backend-sorting
                        >
                            <b-table-column
                                v-for="(f, i) in fields"
                                :key="i"
                                :field="f.key"
                                :width="f.width"
                                :label="$t(f.key)"
                                :sortable="f.sortable"
                                v-slot="props"
                            >
                                <div v-if="f.key == 'codigo'">
                                    <router-link
                                        :to="{
                                            name: 'promotor-atendimento-contrato-view',
                                            params: {
                                                idatendimento: props.row.id,
                                            },
                                        }"
                                    >
                                        {{ props.row[f.key] }}
                                    </router-link>
                                </div>
                                <div v-else-if="f.key == 'contrato'">
                                    <router-link
                                        :to="{
                                            name: 'promotor-atendimento-contrato-view',
                                            params: {
                                                idatendimento: props.row.id,
                                            },
                                        }"
                                    >
                                        {{ props.row[f.key] }}
                                    </router-link>
                                </div>
                                <div v-else-if="f.key == 'dataatendimento'">
                                    {{ props.row[f.key] | moment('L') }}
                                </div>
                                <template v-else>
                                    {{ props.row[f.key] }}
                                </template>
                            </b-table-column>
                        </b-table>
                        <PaginationViewer
                            class="mb-0"
                            :resetPagination="pagination.resetPagination"
                            :totalItems="pagination.totalRows"
                            :perPageOptions="pagination.perPageOptions"
                            :optionStarted="pagination.optionStarted"
                            @change="updatePagination"
                        />
                    </div>
                </div>
            </div>
        </div>

        <lateral-content :isLoading="isLoading" v-model="showFilter" footer>
            <template v-slot:footer-right="{ id }">
                <b-button
                    type="is-warning is-silver"
                    icon-right="backspace"
                    @click="onClearFilters()"
                    class="mr-2"
                    :disabled="isLoading"
                >
                    {{ $t('limpar') }}
                </b-button>
                <b-button
                    type="is-primary"
                    icon-right="filter"
                    @click="
                        carregarDados();
                        showFilter = false;
                    "
                    :disabled="isLoading"
                >
                    {{ $t('filtrar') }}
                </b-button>
            </template>
            <FiltroAtendimento
                ref="filtroRef"
                :filtersReset="filtersReset"
                @update-filtro="updateFiltro"
            />
        </lateral-content>

        <router-view />
    </div>
</template>
<script>
import ProAtendimentoService from '@/services/promotor/ProAtendimentoService.js';
import FiltroRelatorioService from '@/services/FiltroRelatorioService.js';
import ClienteService from '@/services/promotor/ClienteService.js';
import ContainerLoader from '@/components/content/loader/ContainerLoader.vue';
import FiltroAtendimento from '@/components/promotor/relatorio/atendimento/FiltroAtendimento.vue';
import Message from '@/models/Message.js';

export default {
    beforeRouteUpdate(to, from, next) {
        if (
            to.name.includes('promotor-atendimento-contrato') &&
            to.name != 'promotor-atendimento-contrato-list'
        ) {
            this.rotaAninhada = true;
        } else {
            this.rotaAninhada = false;
            this.carregarDados(this.pagination.currentPage);
        }
        next();
    },
    components: {
        FiltroAtendimento,
        ContainerLoader,
    },
    data() {
        return {
            rotaAninhada: false,

            service: new ProAtendimentoService(this.$http, this.$router),
            filtroService: new FiltroRelatorioService(this.$http, this.$router),
            clienteService: new ClienteService(this.$http, this.$router),

            atendimentoList: [],
            // Todos as colunas da tabela
            fields: [
                { key: 'dataatendimento', width: null, sortable: true },
                { key: 'codigo', width: null, sortable: true },
                { key: 'contrato', width: null, sortable: true },
                { key: 'cliente', width: null, sortable: true },
                { key: 'rsocial', width: null, sortable: true },
                { key: 'lps', width: null, sortable: true },
                { key: 'colaborador', width: null, sortable: true },
            ],
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            filters: {
                idempresaList: [],
                idcidadeList: [],
                idestadoList: [],
                idregiaoList: [],
                idclienteList: [],
                idusuarioList: [],
                idredeList: [],
                idbandeiraList: [],
                idlpsList: [],
                idcontratoList: [],
                idtiposervicoList: [],
                column: 'datahorainc',
                order: 'desc',
                searchQuery: '.*',
                situacao: 2,
                idcontrato: 0,
                idlps: 0,
                dataatendimento: new Date(),
            },
            msgs: [],
            showFilter: false,
            filtersReset: false,

            isLoading: false,
            isEmpty: false,

            modalOpen: false,
            debouncedOnSearch: null,
            permissao: {},

            limparFiltro: false,
        };
    },
    created() {
        this.rotaAninhada =
            this.$route.name.includes('promotor-atendimento-contrato') &&
            this.$route.name != 'promotor-atendimento-contrato-list';

        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];
        this.permissao = this.hasPermissionAccess('promotor', 'relatorios', 'report-rota');

        !this.permissao.read &&
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'atendimentos' },
            });

        this.debouncedOnSearch = this.debounce(this.onSearch, 500);

        this.carregarDados();
    },
    methods: {
        validateUrlParams() {
            if (!(this.isNull(this.$route.params.idcontrato) || isNaN(+this.$route.params.idcontrato))) {
                this.filters.idcontrato = this.$route.params.idcontrato;
            } else {
                return false;
            }
            var date = this.$moment(this.$route.params.data);
            if (date.isValid()) {
                this.filters.dataatendimento = this.$route.params.data;
            } else {
                return false;
            }
            return true;
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        onSearch(value) {
            this.filters.searchQuery = this.removeToSearch(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        sortTable(field, order) {
            this.filters.column = field;
            this.filters.order = order;
            this.carregarDados();
        },
        carregarDados(currentPage = 1) {
            if (this.validateUrlParams()) {
                if (currentPage == 1 && this.pagination.currentPage != 1)
                    this.pagination.resetPagination = true;

                this.isLoading = true;

                this.fillFilter(currentPage);
            } else {
                this.atendimentoList = [];
                this.isEmpty = true;
                this.$root.msgs.push(new Message('error', 'parametros-invalidos-na-url'));
            }
        },
        fillFilter(currentPage = 1) {
            this.filters.perPage = this.pagination.perPage;
            this.filters.currentPage = currentPage;
            this.filters.searchQuery = this.filters.searchQuery || '.*';

            this.carregarDadosAtendimentoContrato();
        },
        carregarDadosAtendimentoContrato() {
            this.service
                .findAllByContratoData(this.filters)
                .then(this.mapItems)
                .then((value) => {
                    this.atendimentoList = value;
                    this.isEmpty = this.atendimentoList.length <= 0;
                })
                .catch((e) => {
                    this.atendimentoList = [];
                    this.isEmpty = true;
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;
            return body.content.map((m) => {
                return {
                    id: m.idatendimento,
                    codigo: m.idatendimentoerp,
                    cliente: m.proCliente.nome,
                    rsocial: m.proCliente.rsocial,
                    contrato: m.contrato.descricao,
                    lps: m.proLps.nome,
                    colaborador: m.usuario.nome,
                    dataatendimento: m.dataatendimento,
                };
            });
        },
        onClearFilters() {
            this.$root.confirm({
                message: this.$t('msg-confirm-limpar-filtros'),
                onConfirm: () => this.clearFilter(),
            });
        },
        clearFilter() {
            this.filtersReset = true;

            // this.filters.datainicio = new Date(this.$moment().subtract(30, 'days'));
            // this.filters.datafim = new Date();
            this.filters.searchQuery = '.*';

            this.filters.idempresaList = [];
            this.filters.idcidadeList = [];
            this.filters.idestadoList = [];
            this.filters.idregiaoList = [];
            this.filters.idclienteList = [];
            this.filters.idusuarioList = [];
            this.filters.idredeList = [];
            this.filters.idbandeiraList = [];
            this.filters.idlpsList = [];
            this.filters.idcontratoList = [];
            this.filters.idtiposervicoList = [];

            this.$refs.search.cleanSearch();

            setTimeout(() => {
                this.filtersReset = false;
                this.showFilter = false;
                this.carregarDados();
            }, 1000);
        },
        updateFiltro(filtro) {
            this.filters[filtro.nomeFiltro] = filtro.valor;
        },
    },
};
</script>
<style lang="scss" scoped>
#main2 {
    padding: 0 20px;
    height: 100%;

    .page {
        position: relative;
        padding-left: 0;

        // Barra de filtro
        .filters-bar {
            display: flex;
            align-items: stretch;
            .filters-bar-form {
                flex-grow: 1;
            }
            .filters-bar-actions {
                display: flex;
                padding-bottom: 2px;
                align-items: stretch;
            }

            @media screen and (min-width: 851px) {
                .filters-bar-actions {
                    align-self: flex-end;
                    margin-left: 10px;
                    // margin-bottom: 12px;
                }
            }
            @media screen and (max-width: 850px) {
                flex-direction: column;
                .filters-bar-actions {
                    align-self: center;
                    margin-top: 10px;
                }
            }
        }
    }
    // Filtro lateral
    $width: 400px;
    .filtros-right {
        z-index: 100;
        padding: 15px;
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
        background-color: $darker-bg-color;
        width: $width;
        height: 80%;
        position: fixed;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        border-top: solid 1px #d9d9d9;
        border-left: solid 1px #d9d9d9;
        border-bottom: solid 1px #d9d9d9;
        transition: 0.6s;
        -webkit-box-shadow: 0px 0px 25px 0px rgba(138, 138, 138, 0.8);
        box-shadow: 0px 0px 25px 0px rgba(138, 138, 138, 0.8);

        .filtros-container {
            margin-bottom: 60px;
        }

        .filtros-footer {
            border-bottom-left-radius: 5px;
            background-color: #fff;
            position: absolute;
            padding: 10px;
            bottom: 0;
            left: 0;
            right: 0;
            -webkit-box-shadow: 0px 0px 7px 0px rgba(153, 153, 153, 0.4);
            box-shadow: 0px 0px 7px 0px rgba(153, 153, 153, 0.4);

            .is-silver {
                color: $semi-title-color;
                box-shadow: inset 0px 0px 2px $dark-gray-color-opacity;
                @include exclude-button();
            }
        }
    }
    .hide-filtros-right {
        margin-right: -$width;
    }
    @media screen and (min-height: 850px) {
        .filtros-right {
            height: 50%;
        }
    }
    @media screen and (max-width: 640px) {
        $width: 95%;
        .filtros-right {
            width: $width;
        }
        .hide-filtros-right {
            margin-right: -$width;
        }
    }
}
</style>
